import axios from 'axios';

export const PROTOCOL = process.env.NODE_ENV === 'production' ? 'https' : 'http';

export const BASE_URL = `${PROTOCOL}://${process.env.API_HOST}`;

export default () => axios.create({
  baseURL: BASE_URL,
});



// WEBPACK FOOTER //
// ./src/utils/api.js